import { faCheckCircle, faPrint } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, CircularProgress, Dialog, DialogContent } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom';

export default function ConfirmPrint({ title, download, open, setOpen, loadingPDF, linkTo }) {
    const navigate = useNavigate();

    return (

        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            fullWidth
            maxWidth='sm'
        >
            <DialogContent>
                <div style={{ display: 'flex', alignItems: "center", flexDirection: 'column', width: '100%', paddingBottom: '1rem' }}>
                    <div style={{ width: '100%', textAlign: 'center', paddingBottom: "1rem" }}>
                        <FontAwesomeIcon icon={faCheckCircle} style={{
                            color: '#4AB866',
                            fontSize: '2.3rem'
                        }} />
                    </div>
                    <div style={{ width: '100%', textAlign: 'center' }}>
                        <label style={{
                            fontSize: '1.5rem',
                            fontWeight: 'bold',
                            color: '#4AB866'
                        }}>
                            {title}
                        </label>
                    </div>
                </div>

                <hr />
                <div class="row mt-4">

                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Button variant='outlined' sx={{ width: '120px' }} onClick={() => setOpen(false)}> ปิด</Button>
                        <Button variant='outlined' sx={{ width: '120px', margin: "0 1rem", display: 'flex', alignItems: 'center' }} onClick={download}>{loadingPDF ? <CircularProgress size={'24px'} color="inherit" /> : <><FontAwesomeIcon icon={faPrint} className='me-2' />
                            Print</>} </Button>
                        <Button variant='contained' sx={{ width: '130px' }} onClick={() => {
                            window.location = linkTo
                            setOpen(false)
                        }}>เพิ่มรายการใหม่</Button>
                    </div >
                </div >
            </DialogContent >
        </Dialog >

    )
}
